import React, { Component } from 'react';
import styles from './QRLabel.module.css';
import QRLabelRow from './QRLabelRow';
import { Button, message } from 'antd';
import { rearrange } from 'store/utility';
import QRcode from 'qrcode.react';
import QREditModal from 'components/QRcode/Modal/EditModal';
import { connect } from 'react-redux';

// import { updateProduct } from '../../store/actions/products';

// use data-html2canvas-ignore to ignore canvas renderings
class QRLabel extends Component {
  state = { visible: false };

  formatProduct = product => {
    const data = { ...product };
    // format price format and add array for GST
    data['qrcode_price'] = [`$${(data['price_cents'] / 100).toFixed(2)}`, data['price_format'], data['price_unit']];

    if (data['price_sale'] !== 0) {
      data['qrcode_price'] = [
        `$${(data['price_cents'] / 100).toFixed(2)}`,
        `$${(data['price_sale'] / 100).toFixed(2)}`,
        data['price_sale_format'],
        data['price_unit'],
      ];
    }

    return data;
  };

  renderLabelContents = product => {
    const data = this.formatProduct(product);
    let dataKeys = Object.keys(data).filter(
      e =>
        e !== 'id' &&
        e !== 'series_id' &&
        e !== 'series_title' &&
        e !== 'series' &&
        e !== 'brand_title' &&
        e !== 'description' &&
        e !== 'surface' &&
        e !== 'image_url' &&
        e !== 'stock_level' &&
        e !== 'feature' &&
        e !== 'created_at' &&
        e !== 'updated_at' &&
        e !== 'variation' &&
        e !== 'price_format' &&
        e !== 'price_cents' &&
        e !== 'product_type' &&
        e !== 'application' &&
        e !== 'sub_type' &&
        e !== 'price_unit' &&
        e !== 'is_deleted' &&
        e !== 'gst' &&
        e !== 'gst_sale',
    );
    dataKeys = rearrange(dataKeys);
    let labels = [];
    let counter = 0;
    for (const key of dataKeys) {
      if (key !== undefined) {
        let value = data[key];
        const label = <QRLabelRow settings={this.props.settings} key={counter} label={key} value={value} />;
        labels = [...labels, label];
        counter++;
      }
    }
    return labels;
  };

  saveEditFormRef = form => {
    this.form = form;
  };

  toggleModalHandler = () => {
    const { visible } = this.state;
    setTimeout(() => {
      if (typeof this.form.resetFields !== 'function') {
        console.warn(this.form.resetFields);
        return;
      }
      this.form.resetFields();
    }, 200);
    this.setState(prev => ({ ...prev, visible: !visible }));
  };

  editModalHandler = data => {
    const { updateQRcode, updateProduct } = this.props;
    if (this.form.validateFields) {
      this.form.validateFields((err, value) => {
        if (err) return;
        else {
          updateProduct(data.id, data.product_type, value)
            .then(_ => {
              if (updateQRcode(data, value, this.props.settings) === 'completed') {
                this.setState(prev => ({ ...prev, visible: false }));
                message.success('updated price / remark');
              } else {
                const error = new Error('unable to update QR code cache');
                return Promise.reject(error);
              }
            })
            .catch(console.error);
        }
      });
    }
  };

  deleteQRHandler = id => {
    this.props.deleteQRcode(id);
    message.info('QR code deleted');
  };

  render() {
    const { data } = this.props;
    return (
      <div className={styles.Container}>
        <div className={styles.Title}>
          <span align="center" style={{ fontSize: '20px' }}>
            HAFARY
          </span>
        </div>
        <div className={styles.Content}>{this.renderLabelContents(data)}</div>
        <div className={styles.QRcode}>
          <QRcode
            key={data.id}
            size={45}
            value={data.id.toString()}
            bgColor={'#ffffff'}
            fgColor={'#000000'}
            level={'L'}
          />
        </div>
        <Button
          data-html2canvas-ignore
          shape="circle"
          type="primary"
          icon="edit"
          className={styles.Edit}
          onClick={this.toggleModalHandler}
        />
        <Button
          data-html2canvas-ignore
          shape="circle"
          type="primary"
          icon="delete"
          className={styles.Delete}
          onClick={() => {
            this.deleteQRHandler(data.id);
          }}
        />
        <QREditModal
          onOk={() => this.editModalHandler(data)}
          ref={this.saveEditFormRef}
          onCancel={this.toggleModalHandler}
          visible={this.state.visible}
          data={data}
          isLoading={this.props.isLoading}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    settings: state.setting.settings,
  };
};

export default connect(mapStateToProps)(QRLabel);



// WEBPACK FOOTER //
// ./src/components/QRcode/QRLabel.js